document.addEventListener('DOMContentLoaded', function () {
  function initVideoModule(root) {
    const videos = root.querySelectorAll('.video-module__video');

    // IntersectionObserver to pause videos when not sufficiently visible (e.g., when slides change)
    const observerOptions = { threshold: [0, 0.25, 0.5, 0.75, 1] };
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const vid = entry.target;
        if (!vid) return;
        // If less than half visible, pause
        if (entry.intersectionRatio < 0.5) {
          try { vid.pause(); vid.classList.remove('is-playing'); } catch(e) {}
        }
      });
    }, observerOptions);

    videos.forEach(video => {
      const playButton = video.parentElement.querySelector('.video-module__play-button');
      const container = video.parentElement;

      // observe visibility
      try { io.observe(video); } catch(e) {}

      // hover to play / leave to pause (desktop)
      container.addEventListener('pointerenter', (evt) => {
        // don't autoplay on keyboard focus
        if (evt.pointerType === 'mouse' || evt.pointerType === 'pen' || evt.pointerType === '') {
          try { video.play(); video.classList.add('is-playing'); } catch(e) {}
        }
      });
      container.addEventListener('pointerleave', () => {
        try { video.pause(); video.classList.remove('is-playing'); } catch(e) {}
      });

      // click/tap toggles play/pause for touch devices
      container.addEventListener('click', (evt) => {
        if (evt.target.closest('a')) return;
        if (video.paused) {
          try { video.play(); video.classList.add('is-playing'); } catch(e) {}
        } else {
          try { video.pause(); video.classList.remove('is-playing'); } catch(e) {}
        }
      });

      // keep play button in sync (for accessibility)
      if (playButton) {
        playButton.addEventListener('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          if (video.paused) {
            try { video.play(); video.classList.add('is-playing'); } catch(e) {}
          } else {
            try { video.pause(); video.classList.remove('is-playing'); } catch(e) {}
          }
        });
      }
    });

    // Pause all videos when the page/tab is hidden
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        videos.forEach(v => { try { v.pause(); v.classList.remove('is-playing'); } catch(e) {} });
      }
    });
  }

  document.querySelectorAll('.video-module').forEach(root => initVideoModule(root));
});
